import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="footer">
    <div className="container footer-top">
      <div>
        <span className="brand">
          <b style={{ fontFamily: 'var(--font-display)', fontSize: '1.4rem' }}>Upward Bound</b>
        </span>
        <p className="footer-blurb">
          A nonprofit log cabin retreat serving youth groups, churches and charitable
          organizations — on seven wooded acres in Bristol, New Hampshire, one mile from
          Newfound Lake.
        </p>
      </div>

      <div>
        <h4>Explore</h4>
        <ul>
          <li><Link to="/facilities">Facilities</Link></li>
          <li><Link to="/activities and attractions">Activities</Link></li>
          <li><Link to="/calendar">Calendar</Link></li>
          <li><Link to="/contact">Contact</Link></li>
        </ul>
      </div>

      <div>
        <h4>Reach Us</h4>
        <ul>
          <li><a href="mailto:contact@upwardboundretreat.com">contact@upwardboundretreat.com</a></li>
          <li>(978) 852-5555</li>
          <li>(508) 627-1737</li>
          <li>104 Bristol Hill Rd, Bristol, NH</li>
        </ul>
      </div>
    </div>

    <div className="container">
      <p className="footer-disclaimer">
        Upward Bound Retreat &amp; Camp is operated by Upward Bound Youth Development, Inc.,
        a registered 501(c)(3) nonprofit. Availability is prioritized for youth groups, then
        church and other charitable organizations, with families welcomed as space allows.
      </p>
    </div>

    <div className="container footer-bottom">
      <span>© {new Date().getFullYear()} Upward Bound Youth Development, Inc.</span>
      <span>Bristol, New Hampshire · Lakes Region</span>
    </div>
  </footer>
);

export default Footer;
